module.exports = __webpack_public_path__ + "img/sprinkle-28.1fa37ba0.jpg";